export const SDK__INJECT_TRANSACTION_ID = 'INJECT_TRANSACTION_ID';
export const SDK__INITIALIZED = 'INITIALIZED';
export const SDK__SHOW = 'SHOW';
export const SDK__ON_FINISH = 'FINISH';

let _isIframeCache = null;
let _parentOriginCache = null;
let _showDispatched = false;

export const isIframe = () => {
  if (_isIframeCache !== null) return _isIframeCache;

  try {
    const params = new URLSearchParams(window.location?.search || '');
    if (params.get('iframe') === 'true') {
      _isIframeCache = true;
      return true;
    }

    const isEmbedded = window.self !== window.top;
    _isIframeCache = isEmbedded;
    return isEmbedded;
  } catch (accessError) {
    if (typeof console !== 'undefined' && console.debug) {
      console.debug(
        '[iframe-bridge] window.top access blocked, assuming iframe:',
        accessError?.message,
      );
    }
    _isIframeCache = true;
    return true;
  }
};

export const __resetIframeCache = () => {
  _isIframeCache = null;
  _parentOriginCache = null;
  _showDispatched = false;
};

export const hasDispatchedShow = () => _showDispatched;

export const markShowDispatched = () => {
  _showDispatched = true;
};

const _resolveParentOrigin = () => {
  if (_parentOriginCache) return _parentOriginCache;
  if (typeof document === 'undefined' || !document.referrer) return null;
  try {
    const origin = new URL(document.referrer).origin;
    if (origin && origin !== 'null') {
      _parentOriginCache = origin;
      return _parentOriginCache;
    }
    return null;
  } catch (parseError) {
    if (typeof console !== 'undefined' && console.debug) {
      console.debug(
        '[iframe-bridge] could not parse document.referrer:',
        parseError?.message,
      );
    }
    return null;
  }
};

export const sendPostMessageIframe = (type, data) => {
  if (!isIframe()) return;

  const targetOrigin = _resolveParentOrigin();
  if (!targetOrigin) {
    if (typeof console !== 'undefined' && console.debug) {
      console.debug(
        '[iframe-bridge] no parent origin resolved, dropping postMessage:',
        type,
      );
    }
    return;
  }

  const payload = data ? { type, ...data } : { type };

  try {
    window.parent.postMessage(payload, targetOrigin);
  } catch (postError) {
    if (typeof console !== 'undefined' && console.debug) {
      console.debug('[iframe-bridge] postMessage failed:', postError?.message);
    }
  }
};

export const startListenerIframe = (callbackListener) => {
  if (!isIframe()) return undefined;

  const listener = (event) => {
    if (event?.origin && event.origin !== 'null' && !_parentOriginCache) {
      _parentOriginCache = event.origin;
    }
    if (event?.data && typeof event.data === 'object') {
      callbackListener(event.data);
    }
  };

  window.addEventListener('message', listener);
  sendPostMessageIframe(SDK__INITIALIZED);

  return () => window.removeEventListener('message', listener);
};
